import React from 'react';
import './Otp.css'


const otp = () => {
   

    return(
        <div>
    <div className="container">
      <img src="../assets/Profile.png" alt="profile-icon" className="profile_Otp" height={150}/>
      <h2 className="forgot_password_Otp">Forgot Password ?</h2>
      <p className='we_have_sent'>We have sent you a one time password<br /> on your <b>Email ID</b></p>
      <br />
      <div className='circles'>
        <input className='circlePlaceholders1' placeholder=''></input>
        <input className='circlePlaceholders' placeholder=''></input>
        <input className='circlePlaceholders' placeholder=''></input>
        <input className='circlePlaceholders' placeholder=''></input>
      </div>
      <div className="resend_otp">
        <p className='did_not_receive_otp'>Did not receive OTP?</p>
        <button className="resend_otp_btn" ><b>Resend OTP</b></button>
      </div> 
      <br />
      <button className="register" type="submit" >Register</button>
    </div> 
</div>
    )
}

export default otp;